import { AccessTimeFilled, KeyboardArrowDownOutlined, KeyboardArrowUpOutlined } from '@mui/icons-material';
import { CheckCircle} from 'lucide-react';
import React, { useEffect, useState } from 'react'

export default function TripsHistory() {

    const token = localStorage.getItem("token");  
    const [expandedOrderId, setExpandedOrderId] = useState(null);
    const [ordersByDate, setOrdersByDate] = useState({});

    const formatDate = (dateString) => {
  if (!dateString) return "تاريخ غير محدد";

  const date = new Date(dateString);

  const day = date.getDate().toString().padStart(2, "0");
  const month = date.toLocaleString("en-GB", { month: "long" });
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
    };

     const fetchOrders = async () => {
     try {
     const response = await fetch(
       "https://estbn.com/EstbnNew/public/api/stuff/trips/history",
       {
         headers: {
           Authorization: `Bearer ${token}`,
           Accept: "application/json",
           "Content-Type": "application/json",
         },
       },
     );

     const result = await response.json();
     console.log(result.data.data);
     setOrdersByDate(result.data.data || {});
   } catch (error) {
     console.error("Error fetching orders:", error);
   }
    };

     useEffect(() => { 
    fetchOrders();
    }, []);

  return (
    <div className="w-100 py-4 px-3 px-md-4" dir="rtl">
      {/* orders list */}
      <div className="row g-3">
        <div className="col-12">
          {Object.entries(ordersByDate).map(([date, orders]) => (
            <div key={date} className="mb-4">
              {/* date header */}
              <div dir="ltr" className=" text-end">
                <h6 className="fw-bold text-muted mb-3">{formatDate(date)}</h6>
              </div>

              {orders.map((order) => (
                <div
                  key={order.id}
                  className="mb-3 shadow-sm border-0 rounded-4 overflow-hidden bg-white"
                >
                  {/* num & date */}
                  <div
                    className="d-flex justify-content-between align-items-center p-3 bg-light cursor-pointer"
                    onClick={() =>
                      setExpandedOrderId(
                        expandedOrderId === order.id ? null : order.id,
                      )
                    }
                  >
                    <div className="d-flex align-items-center gap-3">
                      <span className="text-muted small d-none d-sm-inline">
                        طلب رقم
                      </span>
                      <span className="fw-bold fs-6">
                        #{order.door_step_order_id || order.id}
                      </span>
                      <div
                        className="rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                        style={{
                          width: "32px",
                          height: "32px",
                          backgroundColor:
                            order.status === "Completed"
                              ? "#1565AB"
                              : "#7E1BAD",
                          color: "white",
                        }}
                      >
                        {order.status === "Completed" ? (
                          <CheckCircle style={{ fontSize: 18 }} />
                        ) : (
                          <AccessTimeFilled style={{ fontSize: 18 }} />
                        )}
                      </div>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <span className="fw-bold" dir="ltr">
                        {formatDate(order?.ended_at || order?.started_at)}
                      </span>
                      {expandedOrderId === order.id ? (
                        <KeyboardArrowUpOutlined />
                      ) : (
                        <KeyboardArrowDownOutlined />
                      )}
                    </div>
                  </div>
                  {/* expand details */}
                  {expandedOrderId === order.id && (
                    <div className="p-3 p-md-4 bg-white">
                      <div className="p-3 border rounded-4">
                        <div className="mb-3 text-end pb-2 border-bottom">
                          <span className="text-muted small">
                            الخدمة المطلوبة:{" "}
                          </span>
                          <span className="fw-bold text-dark">
                            {order.service_snapshot?.name || "خدمة صيانة"}
                          </span>
                        </div>
                        <div className="row g-3">
                          <div className="col-4 text-end">
                            <p className="text-muted small mb-1">حالة الطلب</p>
                            <p
                              className="fw-bold mb-0"
                              style={{
                                fontSize: "0.85rem",
                                color: "black",
                              }}
                            >
                              {order.status}
                            </p>
                          </div>
                          <div className="col-4 text-end border-end border-start">
                            <p className="text-muted small mb-1">الوقت</p>
                            <p
                              className="fw-bold mb-0"
                              style={{ fontSize: "0.85rem" }}
                            >
                              {order.door_step_order?.scheduled_from} -{" "}
                              {order.door_step_order?.scheduled_to}
                            </p>
                          </div>
                          <div className="col-4">
                            <p className="text-muted small mb-1">العنوان</p>
                            <p
                              className="fw-bold mb-0 text-muted"
                              style={{
                                fontSize: "0.8rem",
                                lineHeight: "1.4",
                              }}
                            >
                              {order?.door_step_order?.address?.district ||
                                "غير متوفر"}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          ))}
          {ordersByDate.length === 0 && (
            <div className="text-center py-5 text-muted">
              لا توجد طلبات مطابقة للبحث
            </div>
          )}
        </div>
      </div>
    </div>
  );
}


   